import {getPrivateAxios} from '../../libs';
import {Collection} from './types';

/**
 *
 * @param guide
 */
export const fetchCollectionUpdate = async (
  collection: Pick<Collection, 'id' | 'name' | 'description'>,
) => {
  const {data} = await getPrivateAxios().patch<Collection>(
    `/collections/${collection.id}`,
    collection,
  );
  return data;
};
